<template>
  <span
    class="rounded-lg font-medium text-xs text-center inline-flex items-center gap-1"
    :class="badgeStyle"
  >
    <i v-if="iconName" :class="`${iconName} text-base leading-4`" />
    <slot>{{ status }}</slot>
  </span>
</template>

<script setup lang="ts">
import { IColors } from "@/types/components/badge";
import { computed } from "vue";

interface Props {
  status: string;
  color: IColors;
  size: "sm" | "md";
  iconName?: string;
}
const props = withDefaults(defineProps<Props>(), {
  color: "green",
  status: "Badge",
  size: "md",
});

const badgeColor = computed(() => {
  switch (props.color) {
    case "green":
      return "bg-green-500/10 text-green";
    case "red":
      return "bg-red-500/10 text-red";
    case "yellow":
      return "bg-yellow-100 text-yellow";
    case "blue":
      return "bg-blue-50 text-blue";
    case "gray":
      return "bg-gray/10 text-gray";
    default:
      return "default";
  }
});

const badgeStyle = computed(() => {
  return `${props.size === "md" ? "px-2 p-1" : "p-1"} ${badgeColor.value}`;
});
</script>
